export default "__VITE_ASSET__DZqpgTtL__"